// Import sprintf-js
import { sprintf } from '@wordpress/i18n';

// Legacy support
export default sprintf;
